function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "thunderstorm"
}, React.createElement("path", {
  id: "cloud",
  d: "M20.06 9.23999C20.06 6.47999 17.84 4.31999 15.14 4.31999C14.54 4.31999 14 4.43999 13.46 4.61999C13.28 2.57999 11.6 0.899994 9.5 0.899994C7.28 0.899994 5.48 2.69999 5.48 4.91999C5.48 5.39999 5.6 5.87999 5.72 6.29999C5.54 6.23999 5.3 6.23999 5.12 6.23999C2.9 6.23999 1.1 8.03999 1.1 10.26C1.1 12.42 2.84 14.22 5 14.28H15.32C17.96 13.98 20.06 11.88 20.06 9.23999Z",
  fill: "#91C0F8",
  stroke: "white",
  strokeWidth: 0.72,
  strokeLinejoin: "round"
}), React.createElement("path", {
  id: "Vector",
  d: "M32.7 18.4C32.7 13.8 29 10.2 24.5 10.2C23.5 10.2 22.6 10.4 21.7 10.7C21.4 7.3 18.6 4.5 15.1 4.5C11.4 4.5 8.4 7.5 8.4 11.2C8.4 12 8.6 12.8 8.8 13.5C8.5 13.4 8.1 13.4 7.8 13.4C4.1 13.4 1.1 16.4 1.1 20.1C1.1 23.7 4 26.7 7.6 26.8H24.8C29.2 26.3 32.7 22.8 32.7 18.4Z",
  fill: "#57A0EE",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinejoin: "round"
}), React.createElement("path", {
  id: "thunder",
  d: "M13.16 18.52H20.6L15.68 27.16H20.36L9.8 39.52L13.88 30.28H9.32L13.16 18.52Z",
  fill: "#FFA500",
  stroke: "white",
  strokeWidth: 1.2
}));

var SvgThunderstorm = function SvgThunderstorm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgThunderstorm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thunderstorm.9287be46.svg";
export { ForwardRef as ReactComponent };